import { UseFormSetValue, FieldValues } from 'react-hook-form';
import { BaseSlide } from '../../../../../models/slides/BaseSlide';
import { getCustomSlide } from './getCustomSlide';

export const updateCustom = ({ slide, setValue, index }: { slide: BaseSlide; setValue: UseFormSetValue<FieldValues>; index: number }) => {
  const customSlide = getCustomSlide(slide);
  setValue(`slideDatas[${index}]`, customSlide);
  return customSlide;
};
